const journeys = {
  JourneysList: {
    title: "Journeys Assistant",
  },
  JourneysFloatingBar: {
    buttonText: "Next",
    patientDetailsText: "Next review lab results and interpretation",
    interpretationDetailsText: "Next review suggested products and resources",
  },
  WomensHormones: {
    menopauseStatus: {
      pre: "Pre-menopause",
      peri: "Peri-menopause",
      post: "Post-menopause",
    },
    menstrualCyclePhase: {
      follicular: "Follicular Phase",
      luteal: "Luteal Phase",
    },
    WomensHormonesRangeUsed: "Reference range used (based on women's hormones survey)",
  },
};

export { journeys };
